interface TelefoneNumberProps {
  number: string;
  onNumberPressed: (number: string) => void;
  disabled?: boolean;
  hidden?: boolean;
}

export function TelefoneNumber({ number, onNumberPressed, disabled = false, hidden = false }: TelefoneNumberProps) {
  return (
    <button
      disabled={disabled}
      className={` digito cursor-default select-none active:bg-blue-950 disabled:bg-blue-300 ${
        hidden ? "invisible" : ""
      }`}
      onClick={() => onNumberPressed(number)}
    >
      {number}
    </button>
  );
}
